var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.statusByProject,"item-text":"name","item-value":"id","hide-details":"auto","label":_vm.$t('tasks.campaign.filter.status.title'),"value":_vm.value,"outlined":"","dense":""},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }